import type { ModeCategoryRow } from "../types/api";

/**
 * Single-language label for category pickers (no "ar · en" dual line).
 * Arabic UI prefers `name_ar`, then `name_en`; other locales prefer `name_en`, then `name_ar`.
 */
export function modeCategoryDisplayName(
  c: Pick<ModeCategoryRow, "name_en" | "name_ar">,
  languageCode: string | undefined,
): string {
  const ar = (c.name_ar ?? "").trim();
  const en = (c.name_en ?? "").trim();
  if (languageCode?.toLowerCase().startsWith("ar")) {
    return ar || en || "—";
  }
  return en || ar || "—";
}

/** Primary display name for analytics (English when available, else Arabic). */
export function modeCategoryPrimaryName(c: Pick<ModeCategoryRow, "name_en" | "name_ar">): string {
  const en = c.name_en?.trim();
  const ar = c.name_ar?.trim();
  return en || ar || "category";
}

export function modeCategoryNamesFromIds(
  ids: number[],
  categories: ModeCategoryRow[] | undefined | null,
): string[] {
  if (!ids.length) return [];
  return ids.map((id) => {
    const row = categories?.find((x) => x.id === id);
    return row ? modeCategoryPrimaryName(row) : `unknown_category_${id}`;
  });
}

export function topicNamesForAnalytics(topic: { name_en?: string; name_ar?: string } | null | undefined): string[] {
  if (!topic) return [];
  const label = modeCategoryPrimaryName({
    name_en: topic.name_en ?? "",
    name_ar: topic.name_ar ?? "",
  });
  return label === "category" ? [] : [label];
}
